import {MenuItem} from './MenuItem';

export class Menu {

    /**
     * @param {Element} element
     * @param {number} depth
     */
    constructor(element, depth = 0) {
        this.element = element;
        this.depth = depth;

        this.items = this.mapItems();
        this._visible = this.element ? this.element.classList.contains('visible') : false;

        if (this.depth === 0) {
            window.addEventListener('click', () => this.visible = false);
        }
    }

    get visible() {
        return this._visible;
    }

    set visible(visible) {
        if (!this.element) {
            return;
        }
        this._visible = visible;
        this.element.classList.toggle('visible', this._visible);
        // If menu is hidden, also hide all submenus
        if (!this._visible) {
            this.items.forEach(menuItem => menuItem.subMenu.visible = this._visible);
        }
    }

    isEmpty() {
        return this.items.length === 0;
    }

    mapItems() {
        return this.element ? Array.from(this.element.children).map(child => new MenuItem(child, this)) : [];
    }

}
